import { FC, memo } from 'react'

import { AvailablePPVWallet } from '@/components/PPVPopup/PPVPopup'
import { useCustomFocus } from '@/hooks'
import { useCommonTranslation } from '@/i18n/useCommonTranslation'

import {
  SelectOption,
  SelectCredits,
  SelectCreditsWrapper,
  SelectTitle,
} from './styles'

type SelectPPVCreditsType = {
  availablePPVWallets: AvailablePPVWallet[]
  activePPVWallet?: AvailablePPVWallet
  setActivePPVWallet: (activePPVWallet: AvailablePPVWallet) => void
}

const SelectPPVCreditsRaw: FC<SelectPPVCreditsType> = ({
  availablePPVWallets,
  activePPVWallet,
  setActivePPVWallet,
}) => {
  const focusId = 'Select_PPV_credits'
  const { t } = useCommonTranslation()
  const { defaultFocusChild, onMove } = useCustomFocus({
    focusId,
  })

  return (
    <SelectCreditsWrapper>
      <SelectTitle>{t('ppvPopup.selectCredits')}</SelectTitle>
      <SelectCredits
        focusId={focusId}
        defaultFocusChild={defaultFocusChild}
        onMove={onMove}
      >
        {availablePPVWallets.map((selectOption) => {
          return (
            <SelectOption
              key={selectOption.walletId}
              onSelected={() => setActivePPVWallet(selectOption)}
              focusId={selectOption.walletId}
              $isActive={selectOption.walletId === activePPVWallet?.walletId}
              $disabled={selectOption.remainingCredits < 0}
            >
              {selectOption.creditsName}
              <span>
                {selectOption.actualCredits}{' '}
                {t('ppvPopup.credit', { count: selectOption.actualCredits })}
              </span>
            </SelectOption>
          )
        })}
      </SelectCredits>
    </SelectCreditsWrapper>
  )
}

export const SelectPPVCredits = memo(SelectPPVCreditsRaw)
